import config from '../../config'

const API_ENDPOINTS = {
    apiUrl: config.apiUrl,
    version: `${config.apiUrl}/version`,
    dimensions: `${config.apiUrl}/v1/dimensions`,
    durations: `${config.apiUrl}/v1/durations`,
    hours: `${config.apiUrl}/v1/hours`,
    interests: `${config.apiUrl}/v1/interests`,
    locations: `${config.apiUrl}/v1/locations`,
    location: `${config.apiUrl}/v1/locations/:locationId`,
    requestUser: `${config.apiUrl}/v1/user`,
    postUser: `${config.apiUrl}/v1/users`,
    getUsers: `${config.apiUrl}/v1/users?offset=:offset&limit=:limit&r=:roleCodes`,
    getUser: `${config.apiUrl}/v1/users/:userId`,
    getUserClasses: `${config.apiUrl}/v1/users/:userId/courses`,
    getUserDroppedClasses: `${config.apiUrl}/v1/users/:userId/drops`,
    getUserGoals: `${config.apiUrl}/v1/users/:userId/goals`,
    getCourses: `${config.apiUrl}/v1/courses?offset=:offset&limit=:limit`,
    course: `${config.apiUrl}/v1/courses/:courseId`,
    courses: `${config.apiUrl}/v1/courses`,
    learningResource: `${config.apiUrl}/v1/learning/resources/:resourceId`,
    learningResourceView: `${config.apiUrl}/v1/learning/resources/:resourceId/view`,
    learningResources: `${config.apiUrl}/v1/learning/resources`,
    users: `${config.apiUrl}/v1/users`,
    user: `${config.apiUrl}/v1/users/:userId`,
    userCourseEnrollment: `${config.apiUrl}/v1/users/:userId/courses/:courseId/enrollment`,
    userCourseEnrollability: `${config.apiUrl}/v1/users/:userId/courses/:courseId/enrollability`,
    userCourseDropability: `${config.apiUrl}/v1/users/:userId/courses/:courseId/dropability`,
    userCourses: `${config.apiUrl}/v1/users/:userId/courses`,
    messages: `${config.apiUrl}/v1/messages`,
    message: `${config.apiUrl}/v1/messages/:messageId`,
    courseAttendees: `${config.apiUrl}/v1/courses/:courseId/attendees`,
    requirements: `${config.apiUrl}/v1/requirements`,
    userGoals: `${config.apiUrl}/v1/users/:userId/goals`,
    userGoal: `${config.apiUrl}/v1/goals/:goalId`,
    reflectionPrompts: `${config.apiUrl}/v1/reflection-prompts`,
    reflectionPrompt: `${config.apiUrl}/v1/reflection-prompts/:promptId`,
    userReflections: `${config.apiUrl}/v1/users/:userId/reflections`,
    userReflection: `${config.apiUrl}/v1/users/:userId/reflections/:promptId`,
    userProgressDimensions: `${config.apiUrl}/v1/users/:userId/progress/dimensions`,
    userInterests: `${config.apiUrl}/v1/users/:userId/interests`,
    systemSettings: `${config.apiUrl}/v1/settings/system`,
    systemSetting: `${config.apiUrl}/v1/settings/system/:settingId`,
    userCourseRatings: `${config.apiUrl}/v1/users/:userId/course-ratings`,
    userCourseRating: `${config.apiUrl}/v1/users/:userId/course-ratings/:ratingId`,
    userFacilitatorRatings: `${config.apiUrl}/v1/users/:userId/facilitator-ratings`,
    userFacilitatorRating: `${config.apiUrl}/v1/users/:userId/facilitator-ratings/:ratingId`,
    jobs: `${config.apiUrl}/v1/jobs`,
    job: `${config.apiUrl}/v1/jobs/:jobId`,
    jobLogs: `${config.apiUrl}/v1/jobs/:jobId/logs`,
    userDiscussions: `${config.apiUrl}/v1/users/:userId/discussions`,
    discussion: `${config.apiUrl}/v1/discussions/:discussionId`,
    discussions: `${config.apiUrl}/v1/discussions`,
    discussionParticipations: `${config.apiUrl}/v1/discussions/:discussionId/participations`,
    courseEnrollees: `${config.apiUrl}/v1/courses/:courseId/enrollees`,
    mobileIOSRedemptions: `${config.apiUrl}/v1/mobile/ios/redemptions`,
    mobileIOSRedeem: `${config.apiUrl}/v1/mobile/ios/redeem`,
    series: `${config.apiUrl}/v1/series/:seriesId`,
    seriesCourses: `${config.apiUrl}/v1/series/:seriesId/courses`,
    mobileAndroidLink: `${config.apiUrl}/v1/mobile/android/link`,
    reports: `${config.apiUrl}/v1/reports`,
    report: `${config.apiUrl}/v1/reports/:reportId`,
    userCourseSurveys: `${config.apiUrl}/v1/users/:userId/surveys/courses`,
    userCourseSurvey: `${config.apiUrl}/v1/users/:userId/surveys/courses/:surveyId`,
    userFacilitatorSurveys: `${config.apiUrl}/v1/users/:userId/surveys/Facilitators`,
    userFacilitatorSurvey: `${config.apiUrl}/v1/users/:userId/surveys/Facilitators/:surveyId`,
    userDimensionCredits: `${config.apiUrl}/v1/users/:userId/dimension-credits`,
    userYearCourses: `${config.apiUrl}/v1/users/:userId/year/courses`,
}

export default API_ENDPOINTS
